<template>
  <el-card>
    <div>
      <!-- 员工管理--列表 -->
      <el-input clearable @keydown.enter.native="searchthis" style="width:280px" placeholder="用户名/手机号/邮箱" v-model="username">
            <el-button slot="append" icon="el-icon-search" @click="searchthis()">搜索</el-button>
      </el-input>
      <el-button class="fr" style="margin-left:20px;" type="primary" @click="addstaff()">添加账号</el-button>
      <el-table border :row-class-name="tableRowClassName" :data="tableData" style="width: 100%;margin-top:20px;">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="roleName" label="角色"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="loginTime" label="最后登录时间"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
             
            <el-button type="text" size="small" @click="edit(scope.row);">编辑</el-button>
            <!-- <el-button @click="deletestaff(scope.row)" type="text" size="small">删除</el-button> -->
            <el-button
              v-if="scope.row.status == 'Y'"
              @click="disableUser(scope.row)"
              type="text"
              size="small"
            >禁用</el-button>
            <el-button type="text" size="mini" v-if="scope.row.status == 'N'" @click="enableUser(scope.row)">启用</el-button>
            <el-button type="text" @click="deletestaff(scope.row)" size="small">删除</el-button>
          <!-- <i v-if="scope.row.status == 'N'" class="el-icon-warning">已禁用</i> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
      style="margin-top:20px;"
        @current-change="handleCurrentChange"
        :page-size="limit"
        :current-page="page"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      page: 1,
      limit: 20,
      formLabelWidth: "120px",
      tableData: [],
      username: ""
    };
  },
  methods: {
      tableRowClassName({row, rowIndex}) {
        // console.log(row)
        if (row.status == 'N') {
          return 'warning-row';
        } 
        // else if (rowIndex === 3) {
        //   return 'success-row';
        // }
        return '';
      },
    getStaffList: async function() {
      var username = this.username;
      var res = await this.$http.get(
        `/v1/busUser/busUserList?username=${username}&page=${this.page}`
      );
      var { code, message, data, total } = res.data;
      if (code == 0) {
        this.total = total;
        this.tableData = data;
      } else {
        this.$message.error(message);
      }
    },
    addstaff: function() {
      this.$router.push("/staffadd");
    },
    edit: function(row) {
      this.$router.push({
        path: "/staffadd",
        query: {
          id: row.id
        }
      });
    },
    deletestaff: async function(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(`/v1/busUser/deleteBusUser?id=${id}`);
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getStaffList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除"
          // });
        });
    },
    // 禁用
    disableUser: async function(row) {
      this.$confirm("是否禁用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(
            `/v1/busUser/enableOrDisableUser?id=${id}`
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("已禁用");
            this.getStaffList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除"
          // });
        });
    },
    // 启用
    enableUser: async function(row) {
      this.$confirm("是否重新启用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(
            `/v1/busUser/enableOrDisableUser?id=${id}`
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("已启用");
            this.getStaffList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除"
          // });
        });
    },
    handleCurrentChange: function(val) {
      this.page = val;
      this.getStaffList();
    },
    searchthis: function() {
      this.page = 1;
      this.getStaffList();
    }
  },
  mounted() {
    this.getStaffList();
  },
  watch: {
    tableData: {
      handler(newName, oldName) {
        if (this.total == (this.page - 1) * this.limit && this.total != 0) {
          //这一行是关键代码，倍数关系
          this.page -= 1;
          if (this.page == 0) {
            this.page = 1;
          }
          this.getStaffList(); //获取表格数据的方法
        }
      },
      // tableData() {  //注意这个函数的名字必须和你监听data中的属性的名字一样，这样才能当你data中的属性发生变化时，触发这个函数
      //   if (this.total == (this.currentPage - 1) * this.pageSize && this.total != 0) { //这一行是关键代码，倍数关系
      //     this.currentPage -= 1
      //     this.getTagData()//获取表格数据的方法
      //   }
      // },
      deep: true
    }
  }
};
</script>

<style lang="scss">
 .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/staff-mg/stafflist.vue